import { nodeEnv } from '../../global';

function isEnvironment(environment: string): boolean {
  return nodeEnv.toLowerCase() === environment.toLowerCase();
}

export { isEnvironment };
